<div class="activities-updater-control" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div cdkDragHandle class="activities-updater-header">
    <h1 mat-dialog-title class="dialog-header">Progress Campaign Activities</h1>
  </div>
  @if (!saveInProgress) {
  <div class="activities-updater-content">
    <div class="span-all-grid-columns" style="margin-left: 0.3rem">
      <div class="top-line-grid">
        <div style="width: 18rem; display: flex; flex-direction: column;">
          <div class="activity-status-wrapper activity-status">
            <div class="status-header ">
              Activity Status
            </div>
            <kendo-dropdownlist [(ngModel)]="currentActivityStatus"
                                [ngModelOptions]="{standalone: true}"
                                [ngClass]="activityStatusClass"
                                [data]="statuses"
                                [textField]="'Name'"
                                [valueField]="'Value'"
                                [valuePrimitive]="false"
                                [size]="'small'"
                                [fillMode]="'flat'"
                                [rounded]="'none'"
                                (valueChange)="handleActivityStatusChange($event)"
                                style="padding: 3px; font-size: 1rem">
            </kendo-dropdownlist>
            <div class="held-date-wrapper">
              <label class="held-date-label">{{heldUntilText}}</label>
              @if (heldUntilText) {
              <kendo-datepicker [size]="'small'" [fillMode]="'flat'" class="held-date" [ngModelOptions]="{standalone: true}" [(ngModel)]="OnHoldDate" placeholder="" (valueChange)="heldDateChange($event)" [disabled]="disableHeldDate">
              </kendo-datepicker>
              }
            </div>
          </div>
        </div>
        <mat-form-field style="padding-right: 20px;">
          <mat-label>Product</mat-label>
          <input matInput (focus)="$event.target.select()" placeholder="Product" [(ngModel)]="Product" maxlength="100" autocomplete="off" />
        </mat-form-field>

        <mat-form-field style="padding-right: 20px;">
          <mat-label>Booking Id</mat-label>
          <input matInput (focus)="$event.target.select()" [ngModelOptions]="{standalone: true}" [(ngModel)]="BookingId" placeholder="Booking Id" maxlength="50" autocomplete="off" />
        </mat-form-field>

        <mat-form-field style="padding-right: 20px;">
          <mat-label>No. Weekly Impressions</mat-label>
          <input matInput [ngModelOptions]="{standalone: true}" [(ngModel)]="Scripts" type="number" min="0" placeholder="No. of Impressions" autocomplete="off" />
        </mat-form-field>

        <div style="display:block;width:100%;flex-wrap:nowrap">
          <mat-form-field style="width:100%;margin:0">
            <kendo-floatinglabel text="Mechanice Type / Digital" style="padding-bottom: 10px;">
              <mat-select [ngModelOptions]="{standalone: true}" [(ngModel)]="currentMechanicType">
                <mat-option [value]="null"></mat-option>
                @for (mechanicType of mechanicTypes; track mechanicType.Id) {
                <mat-option [value]="mechanicType">{{mechanicType.MechanicLabelText}}</mat-option>
                }
              </mat-select>
            </kendo-floatinglabel>
          </mat-form-field>

        </div>
      </div>
    </div>

    <!-- NEW: Contacts + Booking -->
    <div class="span-all-grid-columns" style="margin-left: 0.3rem">
      <fieldset>
        <legend>Contacts</legend>
        <div class="credit-line-grid">
          <contacts-selector contactPopUpClass="popup-class-activity-contact" [required]="false" [isDisabled]="false" [(value)]="currentClientExecutive" [data]="commonDataService.clientExecutives()" hasNoneSelectedOption="true" [ngModelOptions]="{standalone: true}">
          </contacts-selector>
          <contacts-selector contactPopUpClass="popup-class-activity-contact" [required]="false" [isDisabled]="false" [(value)]="currentClientSupport" [data]="commonDataService.clientSupport()" hasNoneSelectedOption="true" [ngModelOptions]="{standalone: true}">
          </contacts-selector>
          <contacts-selector contactPopUpClass="popup-class-activity-contact" [required]="false" [isDisabled]="false" [(value)]="currentBriefManager" [data]="commonDataService.briefManagers()" hasNoneSelectedOption="true" [ngModelOptions]="{standalone: true}">
          </contacts-selector>
          <contacts-selector contactPopUpClass="popup-class-activity-contact" [required]="false" [isDisabled]="false" [(value)]="currentProgrammer" [data]="commonDataService.programmers()" hasNoneSelectedOption="true" [ngModelOptions]="{standalone: true}">
          </contacts-selector>
        </div>
      </fieldset>
    </div>

    <!-- Existing Credit Line section (unchanged) -->
    <div class="span-all-grid-columns" style="margin-left: 0.3rem">
      <fieldset>
        <legend>Credit Line</legend>
        <div class="credit-line-grid">
          @if (showCreditLineType) {
          <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select [ngModelOptions]="{standalone: true}" [(ngModel)]="CreditLineTypeId">
              <mat-option [value]="0" selected>None</mat-option>
              <mat-option [value]="1">New</mat-option>
              <mat-option [value]="2">Repeat</mat-option>
              <mat-option [value]="3">Existing</mat-option>
            </mat-select>
          </mat-form-field>
          }
          @if (showCreditLineRotation) {
          <mat-form-field>
            <mat-label>Rotation</mat-label>
            <mat-select [ngModelOptions]="{standalone: true}" [(ngModel)]="CreditLineRotationTypeId">
              <mat-option [value]="0" selected>None</mat-option>
              <mat-option [value]="1">Even</mat-option>
              <mat-option [value]="2">100%</mat-option>
              <mat-option [value]="3">Other</mat-option>
            </mat-select>
          </mat-form-field>
          }
          <mat-form-field>
            <mat-label>Credit Line Due Date</mat-label>
            <input matInput [matDatepicker]="creditlineduedate" [ngModelOptions]="{standalone: true}" [(ngModel)]="CreditLineDueDate" placeholder="Credit Line Due Date" autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="creditlineduedate"></mat-datepicker-toggle>
            <mat-datepicker #creditlineduedate startView="month" [startAt]="CreditLineDueDate"></mat-datepicker>
          </mat-form-field>
          @if (showCreditLine) {
          <kendo-formfield class="span-all-grid-columns">
            <kendo-floatinglabel text="Credit Line / Talent Requirements">
              <kendo-textarea [size]="'small'" [fillMode]="'flat'" rows="5" selectOnFocus="true" title="CreditLine" [ngModelOptions]="{standalone: true}" [(ngModel)]="CreditLine" maxlength="2000"></kendo-textarea>
            </kendo-floatinglabel>
          </kendo-formfield>
          }
          @if (showCreditLineNotes) {
          <div class="span-all-grid-columns">
            <kendo-floatinglabel text="Credit Notes">
              <kendo-textarea [size]="'small'" [fillMode]="'flat'" rows="5" selectOnFocus="true" title="CreditLineNotes" [ngModelOptions]="{standalone: true}" [(ngModel)]="CreditLineNotes" maxlength="2000"></kendo-textarea>
            </kendo-floatinglabel>
          </div>
          }
        </div>
      </fieldset>
    </div>

    <!-- NEW: Prizing -->
    <div class="span-all-grid-columns" style="margin-left: 0.3rem">
      <fieldset>
        <legend>Prizing</legend>
        <div class="prizing-line-grid">
          <kendo-floatinglabel text="Minor Prizing / Staff Request / Initiative">
            <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="MinorPrize" maxlength="500" autocomplete="off"></kendo-textbox>
          </kendo-floatinglabel>
          <mat-form-field style="grid-area: 2 / 1">
            <mat-label>Minor Prizing Fulfilment / Custom Detail</mat-label>
            <textarea (focus)="$event.target.select()" matInput rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="MinorPrizeHowFulFilled" maxlength="500" autocomplete="off"></textarea>
          </mat-form-field>
          <kendo-floatinglabel text="Major Prizing">
            <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="MajorPrize" maxlength="500" autocomplete="off"></kendo-textbox>
          </kendo-floatinglabel>
          <mat-form-field style="grid-area: 2 / 2">
            <mat-label>Major Prizing Fulfilment</mat-label>
            <textarea (focus)="$event.target.select()" matInput rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="MajorPrizeHowFulFilled" maxlength="500" autocomplete="off"></textarea>
          </mat-form-field>
        </div>
      </fieldset>
    </div>

    <div class="span-all-grid-columns" style="margin-left: 0.3rem">
      <fieldset>
        <legend>Station / Implementation Details</legend>
        <div class="details-line-grid">
          <mat-card appearance="outlined" class="control-mat-card-vertical">
            <kendo-floatinglabel text="Activity / Partnership / Feature Name">
              <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="ActivityName" maxlength="100" autocomplete="off"></kendo-textbox>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Onsite Contact">
              <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="OnsiteContactName" maxlength="200" autocomplete="off"></kendo-textbox>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Onsite Contact Phone">
              <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="OnsiteContactTel" maxlength="25" autocomplete="off"></kendo-textbox>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Third Party (eg Ticketing)">
              <kendo-textbox selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" [ngModelOptions]="{standalone: true}" [(ngModel)]="TicketingOutlet" maxlength="200" autocomplete="off"></kendo-textbox>
            </kendo-floatinglabel>
          </mat-card>

          <mat-card appearance="outlined" class="control-mat-card-vertical">
            <mat-form-field>
              <mat-label>Revenue</mat-label>
              <input matInput (focus)="$event.target.select()" type="number" min="0" [ngModelOptions]="{standalone: true}" [(ngModel)]="Revenue" autocomplete="off" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Production</mat-label>
              <input matInput (focus)="$event.target.select()" type="number" min="0" [ngModelOptions]="{standalone: true}" [(ngModel)]="Production" autocomplete="off" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Digital Revenue / Talent Fee</mat-label>
              <input matInput (focus)="$event.target.select()" type="number" min="0" [ngModelOptions]="{standalone: true}" [(ngModel)]="MultimediaRecovery" autocomplete="off" />
            </mat-form-field>
          </mat-card>

          <mat-card appearance="outlined" class="control-mat-card-vertical">
            <div>
              <kendo-floatinglabel text="On Air Time">
                <kendo-timepicker [size]="'small'" [fillMode]="'flat'" [(ngModel)]="OnAirTime" [format]="'HH:mm'" [popupSettings]="popupSettings" placeholder=""></kendo-timepicker>
              </kendo-floatinglabel>
            </div>
            <div>
              <kendo-floatinglabel text="Onsite Start Time">
                <kendo-timepicker [size]="'small'" [fillMode]="'flat'" [(ngModel)]="StartTime" [format]="'HH:mm'" [popupSettings]="popupSettings" placeholder=""></kendo-timepicker>
              </kendo-floatinglabel>
            </div>
            <div>
              <kendo-floatinglabel text="Onsite End Time">
                <kendo-timepicker [size]="'small'" [fillMode]="'flat'" [(ngModel)]="EndTime" [format]="'HH:mm'" [popupSettings]="popupSettings" placeholder=""></kendo-timepicker>
              </kendo-floatinglabel>
            </div>
          </mat-card>

          <mat-card appearance="outlined" class="control-mat-card-one-line" style="grid-column: 1 / -1">
            <mat-card appearance="outlined" class="control-mat-card-vertical">
              <kendo-floatinglabel text="Mechanic / What's Happening / Detailed Promotional Support'">
                <kendo-textarea selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="Mechanic" maxlength="3000" autocomplete="off"></kendo-textarea>
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Airtime Detail">
                <kendo-textarea selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="AirtimeBreakdown" maxlength="600" autocomplete="off"></kendo-textarea>
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Location Address">
                <kendo-textarea selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="LocationAddress" maxlength="500" autocomplete="off"></kendo-textarea>
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Signage / Event Date(s)">
                <kendo-textarea selectOnFocus="true" [size]="'small'" [fillMode]="'flat'" rows="3" [ngModelOptions]="{standalone: true}" [(ngModel)]="SignageRequired" maxlength="1000" autocomplete="off"></kendo-textarea>
              </kendo-floatinglabel>
            </mat-card>
          </mat-card>
        </div>
      </fieldset>
    </div>
  </div>
  }
  @if (saveInProgress) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    @if (saveInProgress) {
    <label class="spinner-loading-label">Progressing Activities, please wait...</label>
    }
  </div>
  }
  <div class="activities-updater-footer">
    <hr />
    <mat-dialog-actions>
      <div class="button-row">
        <button mat-button [disabled]="saveInProgress" (click)="onCancelClick()">Close</button>
        <button mat-stroked-button [disabled]="saveInProgress" color="primary" (click)="progressActivities($event)" [disabled]="!activities || activities?.length < 1" title="Click to progress the status and set details for selected activities">Progress Selected Activities</button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
